<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="field mt1 has-text-left">
        <label>Select a date range:</label>
        <div class="control has-icons-right">
          <flat-pickr
            v-model="date"
            :config="config"
            input-class="input"
          ></flat-pickr>
          <span class="icon is-right"><i class="icon icon-calendar"></i></span>
        </div>

        <label class="mt1">Select a time range:</label>
        <div class="columns is-mobile mt1 time-select">
          <div class="column is-one-third">
            <button
              type="button"
              :class="[
                'button',
                'time',
                'is-fullwidth',
                { 'is-active': time === 'Anytime' }
              ]"
              @click="setTime('Anytime')"
            >
              Anytime
            </button>
          </div>
          <div class="column is-one-third">
            <button
              type="button"
              :class="[
                'button',
                'time',
                'is-fullwidth',
                { 'is-active': time === 'Morning' }
              ]"
              @click="setTime('Morning')"
            >
              Morning
            </button>
          </div>
          <div class="column is-one-third">
            <button
              type="button"
              :class="[
                'button',
                'time',
                'is-fullwidth',
                { 'is-active': time === 'Afternoon' }
              ]"
              @click="setTime('Afternoon')"
            >
              Afternoon
            </button>
          </div>
        </div>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import flatPickr from "vue-flatpickr-component";
import "../../../node_modules/flatpickr/dist/flatpickr.css";
import baseQuestion from "./baseQuestion";

export default {
  name: "schedule",

  mixins: [baseQuestion],

  components: {
    flatPickr
  },

  data() {
    return {
      date: null,
      config: {
        inline: true,
        mode: "range",
        dateFormat: "M j, y",
        minDate: "today"
      },
      time: "Anytime"
    };
  },

  watch: {
    date() {
      this.recordAnswer();
    }
  },

  methods: {
    setTime(time) {
      this.time = time;
      this.recordAnswer();
    },
    recordAnswer() {
      this.choice = { date_range: this.date, time: this.time };
      this.$store.dispatch("interview/setNext", true);
    }
  },

  mounted() {
    if (_.has(this.choice, "date_range")) {
      this.date = this.choice.date_range;
      this.time = this.choice.time;
    }
  }
};
</script>

<style lang="scss">
.date-range-picker {
  h3,
  legend {
    display: none;
  }
}

.time {
  background: #f5f7f9;

  &.is-active {
    background: #4daefc;
  }
}
</style>
